<!-- 课程列表 -->
<template>
  <div class="container">
    <Head :isShow="back"></Head>
    <!--课程介绍-->
    <div class="currbox">
      <div class="currhead">
        <h1 class="currh1">
          {{
            courseData.courseTitle
              ? courseData.courseTitle
              : courseData.courseName
          }}
        </h1>
        <div v-if="back" @click="slices" class="currfont">
          返回
          <img
            alt
            src="@/assets/img/slices/slices.png"
            style="margin-left: 10px; cursor: pointer"
          />
        </div>
      </div>
      <div class="currfontes">
        {{ courseData.keywords }}
        <span v-if="textCount < 9999"></span>
      </div>
    </div>
    <!--课程，题库，资料-->
    <div class="Box">
      <div class="tabBox">
        <el-tabs v-model="activeName">
          <el-tab-pane label="课程" name="first">
            <div>
              <div class="switchBox">
                <div
                  :class="{ active: navActiveIndex === 1 }"
                  @click="tabClicked(1)"
                  class="buttontabes"
                >
                  课程视频
                </div>
              </div>
              <div class="paddingBox" v-show="showdata">
                <div class="course-details-nav-content-2">
                  <el-menu
                    @open="handleOpen"
                    active-text-color="$color"
                    class="el-menu-vertical-demo"
                  >
                    <template></template>
                    <el-submenu
                      :index="String(index1)"
                      :key="index1"
                      v-for="(item, index1) in courseList"
                    >
                      <template slot="title">
                        <div style="color: #1a1a1a; display: flex">
                          <div style="width: 100px">
                            第 {{ index1 + 1 }} 章节
                          </div>
                          <div
                            v-if="!isRecommend"
                            style="padding-left: 0.5rem; width: 500px"
                          >
                            {{ item.catalogName }}
                          </div>
                          <div
                            v-if="isRecommend && item.channelHaveFreeGood"
                            style="padding-left: 0.5rem; width: 500px"
                          >
                            {{ item.catalogName
                            }}<span style="color: green">(包含免费视频)</span>
                          </div>
                          <div
                            v-if="isRecommend && !item.channelHaveFreeGood"
                            style="padding-left: 0.5rem; width: 500px"
                          >
                            {{ item.catalogName }}
                          </div>
                          <div>课时数 {{ item.classCount }}</div>
                        </div>
                      </template>
                      <el-menu-item-group style="background-color: #fafafa">
                        <el-menu-item
                          :index="String(index1 + '-' + index2)"
                          :key="index2"
                          v-for="(cItem, index2) in item.courseGoodsList"
                        >
                          <div class="course-list-item-box">
                            <div class="course-list-item-name coure">
                              <img alt src="@/assets/img/videoicon.png" />
                              <div>
                                课时 {{ index2 + 1 }} ：{{ cItem.goodsName }}
                              </div>
                              <div
                                v-text="'时长：' + getDuration(cItem.catLength)"
                              ></div>
                              <div class="nt">
                                <div
                                  v-if="
                                    !isRecommend &&
                                    cItem.courseGoodsLearnLogEntity &&
                                    cItem.courseGoodsLearnLogEntity.playTime <
                                      cItem.courseGoodsLearnLogEntity
                                        .courseGoodsEntity.catLength
                                  "
                                  v-show="
                                    cItem.courseGoodsLearnLogEntity.playTime
                                  "
                                >
                                  已学：{{
                                    getDuration(
                                      cItem.courseGoodsLearnLogEntity.playTime
                                        ? cItem.courseGoodsLearnLogEntity
                                            .playTime
                                        : 0
                                    )
                                  }}
                                </div>
                                <div
                                  v-if="
                                    !isRecommend &&
                                    cItem.courseGoodsLearnLogEntity &&
                                    cItem.courseGoodsLearnLogEntity.playTime >=
                                      cItem.courseGoodsLearnLogEntity
                                        .courseGoodsEntity.catLength
                                  "
                                >
                                  已学完
                                </div>
                              </div>
                              <div>
                                <el-button
                                  @click="infoVido(cItem)"
                                  size="small"
                                  type="text"
                                  v-if="
                                    !isRecommend &&
                                    cItem.courseGoodsLearnLogEntity
                                  "
                                  >继续学习</el-button
                                >
                                <el-button
                                  size="small"
                                  type="text"
                                  v-if="!isRecommend"
                                  v-show="cItem.is_free == 1"
                                  >再学习</el-button
                                >
                                <el-button
                                  @click="infoVido(cItem)"
                                  size="small"
                                  type="text"
                                  v-if="
                                    !isRecommend &&
                                    !cItem.courseGoodsLearnLogEntity
                                  "
                                  >开始学习</el-button
                                >
                                <el-button
                                  @click="buycourse()"
                                  size="small"
                                  type="text"
                                  v-if="isRecommend && !cItem.channelFree"
                                  >开通课程</el-button
                                >
                                <el-button
                                  @click="infoVido(cItem)"
                                  size="success"
                                  type="text"
                                  v-if="isRecommend && cItem.channelFree"
                                  style="color: green"
                                  >免费试看</el-button
                                >
                              </div>
                            </div>
                          </div>
                        </el-menu-item>
                      </el-menu-item-group>
                    </el-submenu>
                  </el-menu>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="题库" name="second">
            <div>
              <div class="switchBox">
                <div
                  :class="showdataes ? 'buttontabes' : 'buttontab'"
                  @click="currvideo('appear', 1)"
                >
                  习题练习
                </div>
                <div
                  :class="showdaes ? 'buttontabes' : 'buttontab'"
                  @click="currvideo('appear', 2)"
                >
                  错题本
                </div>
                <div
                  :class="showeaes ? 'buttontabes' : 'buttontab'"
                  @click="currvideo('appear', 3)"
                >
                  习题收藏
                </div>
              </div>
              <div class="paddingBox" v-show="showdataes">
                <el-table
                  :data="MyExaminationList"
                  :show-header="showHeader"
                  style="width: 100%"
                >
                  <el-table-column label="日期" width="60">
                    <template slot-scope="scope">
                      <img
                        alt
                        src="@/assets/img/Exam/realQuestion.png"
                        v-if="
                          scope.row.typeId == 1 ||
                          scope.row.typeId == 5 ||
                          scope.row.typeId == 6 ||
                          scope.row.typeId == 7 ||
                          scope.row.typeId == 15
                        "
                      />
                      <img
                        alt
                        src="@/assets/img/Exam/chapter.png"
                        v-if="
                          scope.row.typeId == 2 ||
                          scope.row.typeId == 8 ||
                          scope.row.typeId == 9 ||
                          scope.row.typeId == 10
                        "
                      />
                      <img
                        alt
                        src="@/assets/img/Exam/simulation.png"
                        v-if="
                          scope.row.typeId == 3 ||
                          scope.row.typeId == 11 ||
                          scope.row.typeId == 12 ||
                          scope.row.typeId == 13
                        "
                      />
                      <img
                        alt
                        src="@/assets/img/Exam/secretVolume.png"
                        v-if="scope.row.typeId == 4"
                      />
                      <img
                        alt
                        src="@/assets/img/Exam/chapter.png"
                        v-if="scope.row.typeId > 15"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="日期" width="200">
                    <template slot-scope="scope">
                      <span style="margin-left: 10px">{{
                        scope.row.examinationName
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="题数" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.questionCount > 0"
                        >共 {{ scope.row.questionCount }}道题</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="已做数" width="150">
                    <template slot-scope="scope">
                      <span
                        v-if="
                          scope.row.customerExaminationTestLogEntity &&
                          !isRecommend
                        "
                        >已做
                        {{
                          scope.row.customerExaminationTestLogEntity
                            .testedCount
                        }}道题</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="正确数" width="100">
                    <template slot-scope="scope">
                      <span
                        v-if="
                          scope.row.customerExaminationTestLogEntity &&
                          Number(
                            scope.row.customerExaminationTestLogEntity.isCommit
                          ) >= 1 &&
                          !isRecommend
                        "
                        >答对
                        {{
                          scope.row.customerExaminationTestLogEntity.trueCount
                        }}道题</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template fixed="right" slot-scope="scope">
                      <el-button
                        @click="pushParing(scope.row)"
                        class="rightrow"
                        size="mini"
                        v-if="
                          !isRecommend &&
                          scope.row.customerExaminationTestLogEntity &&
                          Number(
                            scope.row.customerExaminationTestLogEntity.isCommit
                          ) === 1 &&
                          !isRecommend
                        "
                      >
                        <img alt src="@/assets/img/Exam/解析.png" />
                        查看解析
                      </el-button>
                      <el-button
                        @click="openCenterDialogVisible(scope.row, 3)"
                        class="rightrow"
                        size="mini"
                        v-if="
                          !isRecommend &&
                          scope.row.customerExaminationTestLogEntity &&
                          Number(
                            scope.row.customerExaminationTestLogEntity.isCommit
                          ) === 1 &&
                          !isRecommend
                        "
                      >
                        <img alt src="@/assets/img/Exam/返回.png" />
                        重新答题
                      </el-button>
                      <el-button
                        @click="again(scope.row, 2)"
                        class="rightrow"
                        size="mini"
                        v-if="
                          !isRecommend &&
                          scope.row.customerExaminationTestLogEntity &&
                          Number(
                            scope.row.customerExaminationTestLogEntity.isCommit
                          ) === 2
                        "
                        >继续答题</el-button
                      >
                      <el-button
                        @click="openCenterDialogVisible(scope.row, 1)"
                        class="rightrow"
                        size="mini"
                        v-if="
                          !isRecommend &&
                          !scope.row.customerExaminationTestLogEntity
                        "
                        v-show="1 == 1"
                        >开始答题</el-button
                      >
                      <el-button
                        @click="buycourse()"
                        class="rightrow"
                        size="mini"
                        v-if="isRecommend"
                        v-show="1 == 1"
                        >开通课程</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="paddingBox" v-if="!isRecommend" v-show="showdaes">
                <el-table
                  :data="examinationItemWrongList"
                  :show-header="showHeader"
                  style="width: 100%"
                >
                  <el-table-column label="日期" width="60">
                    <template>
                      <img alt src="@/assets/img/icon.png" />
                    </template>
                  </el-table-column>
                  <el-table-column label="日期" width="600">
                    <template slot-scope="scope">
                      <span style="margin-left: 10px">{{
                        scope.row.examinationName
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="题数" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.questionCount > 0"
                        >共 {{ scope.row.questionCount }}道题</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="错题" width="100">
                    <template slot-scope="scope">
                      <span>{{ scope.row.wrongCount }}道错题</span>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        @click="openWrong(scope.row)"
                        class="rightrow"
                        size="mini"
                        >查看错题</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="paddingBox" v-if="!isRecommend" v-show="showeaes">
                <el-table
                  :data="ExaminationItemCollectExamination"
                  :show-header="showHeader"
                  style="width: 100%"
                >
                  <el-table-column label="日期" width="60">
                    <template>
                      <img alt src="@/assets/img/icon.png" />
                    </template>
                  </el-table-column>
                  <el-table-column label="日期" width="600">
                    <template slot-scope="scope">
                      <span style="margin-left: 10px">{{
                        scope.row.examinationName
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="收藏" width="100">
                    <template slot-scope="scope">
                      <span>收藏 {{ scope.row.wrongCount }}道</span>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        @click="openBankKeep(scope.row)"
                        class="rightrow"
                        size="mini"
                        >前往查看</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="资料" name="third">
            <div>
              <div class="paddingBox">
                <el-table
                  :data="datumList"
                  :show-header="showHeader"
                  style="width: 100%"
                >
                  <el-table-column label="图标" width="60">
                    <template>
                      <img alt src="@/assets/img/pdf.png" />
                    </template>
                  </el-table-column>
                  <el-table-column label="标题" width="1020">
                    <template slot-scope="scope">
                      <span style="margin-left: 10px">{{
                        scope.row.datumName
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        @click="downloadDatum(scope.row)"
                        class="filter-item"
                        icon="el-icon-download"
                        size="mini"
                        type="primary"
                        v-if="!isRecommend"
                        >下载查看</el-button
                      >
                      <el-button
                        @click="buycourse()"
                        class="filter-item"
                        size="mini"
                        type="primary"
                        v-if="isRecommend"
                        >开通课程</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="考前串讲" name="ban" v-if="courseTalkList.length">
            <div>
              <div class="switchBox">
                <div
                  :class="{ active: navActiveIndex === 2 }"
                  @click="tabClicked(2)"
                  class="buttontabes"
                >
                  考前串讲
                </div>
              </div>
              <div class="paddingBox" v-show="showdata">
                <div class="course-details-nav-content-2">
                  <el-menu
                    @open="handleOpen"
                    active-text-color="$color"
                    class="el-menu-vertical-demo"
                  >
                    <el-submenu
                      :index="String(index1)"
                      :key="index1"
                      v-for="(item, index1) in courseTalkList"
                    >
                      <template slot="title">
                        <div style="color: #1a1a1a; display: flex">
                          <div style="width: 100px">
                            第 {{ index1 + 1 }} 章节
                          </div>
                          <div
                            v-if="!isRecommend"
                            style="padding-left: 0.5rem; width: 500px"
                          >
                            {{ item.catalogName }}
                          </div>
                          <div
                            v-if="isRecommend && item.channelHaveFreeGood"
                            style="padding-left: 0.5rem; width: 500px"
                          >
                            {{ item.catalogName
                            }}<span style="color: green">(包含免费视频)</span>
                          </div>
                          <div
                            v-if="isRecommend && !item.channelHaveFreeGood"
                            style="padding-left: 0.5rem; width: 500px"
                          >
                            {{ item.catalogName }}
                          </div>

                          <div>课时数 {{ item.classCount }}</div>
                        </div>
                      </template>
                      <el-menu-item-group style="background-color: #fafafa">
                        <el-menu-item
                          :index="String(index1 + '-' + index2)"
                          :key="index2"
                          v-for="(cItem, index2) in item.courseGoodsList"
                        >
                          <div class="course-list-item-box">
                            <div class="course-list-item-name coure">
                              <img alt src="@/assets/img/videoicon.png" />
                              <div>
                                课时 {{ index2 + 1 }} ：{{ cItem.goodsName }}
                              </div>
                              <div
                                v-text="'时长：' + getDuration(cItem.catLength)"
                              ></div>
                              <div class="nt">
                                <div
                                  v-if="
                                    !isRecommend &&
                                    cItem.courseGoodsLearnLogEntity &&
                                    cItem.courseGoodsLearnLogEntity.playTime <
                                      cItem.courseGoodsLearnLogEntity
                                        .courseGoodsEntity.catLength
                                  "
                                  v-show="
                                    cItem.courseGoodsLearnLogEntity.playTime
                                  "
                                >
                                  已学：{{
                                    getDuration(
                                      cItem.courseGoodsLearnLogEntity.playTime
                                        ? cItem.courseGoodsLearnLogEntity
                                            .playTime
                                        : 0
                                    )
                                  }}
                                </div>
                                <div
                                  v-if="
                                    !isRecommend &&
                                    cItem.courseGoodsLearnLogEntity &&
                                    cItem.courseGoodsLearnLogEntity.playTime >=
                                      cItem.courseGoodsLearnLogEntity
                                        .courseGoodsEntity.catLength
                                  "
                                >
                                  已学完
                                </div>
                              </div>
                              <div>
                                <el-button
                                  @click="infoVido(cItem)"
                                  size="small"
                                  type="text"
                                  v-if="
                                    !isRecommend &&
                                    cItem.courseGoodsLearnLogEntity
                                  "
                                  >继续学习</el-button
                                >
                                <el-button
                                  size="small"
                                  type="text"
                                  v-if="!isRecommend"
                                  v-show="cItem.is_free == 1"
                                  >再学习</el-button
                                >
                                <el-button
                                  @click="infoVido(cItem)"
                                  size="small"
                                  type="text"
                                  v-if="
                                    !isRecommend &&
                                    !cItem.courseGoodsLearnLogEntity
                                  "
                                  >开始学习</el-button
                                >
                                <el-button
                                  @click="buycourse()"
                                  size="small"
                                  type="text"
                                  v-if="isRecommend && !cItem.channelFree"
                                  >开通课程</el-button
                                >
                                <el-button
                                  @click="infoVido(cItem)"
                                  size="success"
                                  type="text"
                                  v-if="isRecommend && cItem.channelFree"
                                  style="color: green"
                                  >免费试看</el-button
                                >
                              </div>
                            </div>
                          </div>
                        </el-menu-item>
                      </el-menu-item-group>
                    </el-submenu>
                  </el-menu>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="真题讲解"
            name="tai"
            v-if="courseTopicList.length"
          >
            <div>
              <div class="switchBox">
                <div
                  :class="{ active: navActiveIndex === 3 }"
                  @click="tabClicked(3)"
                  class="buttontabes"
                >
                  真题讲解
                </div>
              </div>
              <div class="paddingBox" v-show="showdata">
                <div
                  class="course-details-nav-content-2"
                  v-show="navActiveIndex === 3"
                >
                  <el-menu
                    @open="handleOpen"
                    active-text-color="$color"
                    class="el-menu-vertical-demo"
                    default-active="3"
                  >
                    <el-submenu
                      :index="String(index1)"
                      :key="index1"
                      v-for="(item, index1) in courseTopicList"
                    >
                      <template slot="title">
                        <div style="color: #1a1a1a; display: flex">
                          <div style="width: 100px">
                            第 {{ index1 + 1 }} 章节
                          </div>
                          <div
                            v-if="!isRecommend"
                            style="padding-left: 0.5rem; width: 500px"
                          >
                            {{ item.catalogName }}
                          </div>
                          <div
                            v-if="isRecommend && item.channelHaveFreeGood"
                            style="padding-left: 0.5rem; width: 500px"
                          >
                            {{ item.catalogName
                            }}<span style="color: green">(包含免费视频)</span>
                          </div>
                          <div
                            v-if="isRecommend && !item.channelHaveFreeGood"
                            style="padding-left: 0.5rem; width: 500px"
                          >
                            {{ item.catalogName }}
                          </div>
                          <div>课时数 {{ item.classCount }}</div>
                        </div>
                      </template>
                      <el-menu-item-group style="background-color: #fafafa">
                        <el-menu-item
                          :index="String(index1 + '-' + index2)"
                          :key="index2"
                          v-for="(cItem, index2) in item.courseGoodsList"
                        >
                          <div class="course-list-item-box">
                            <div class="course-list-item-name coure">
                              <img alt src="@/assets/img/videoicon.png" />
                              <div>
                                课时 {{ index2 + 1 }} ：{{ cItem.goodsName }}
                              </div>
                              <div
                                v-text="'时长：' + getDuration(cItem.catLength)"
                              ></div>
                              <div class="nt">
                                <div
                                  v-if="
                                    !isRecommend &&
                                    cItem.courseGoodsLearnLogEntity &&
                                    cItem.courseGoodsLearnLogEntity.playTime <
                                      cItem.courseGoodsLearnLogEntity
                                        .courseGoodsEntity.catLength
                                  "
                                  v-show="
                                    cItem.courseGoodsLearnLogEntity.playTime
                                  "
                                >
                                  已学：{{
                                    getDuration(
                                      cItem.courseGoodsLearnLogEntity.playTime
                                        ? cItem.courseGoodsLearnLogEntity
                                            .playTime
                                        : 0
                                    )
                                  }}
                                </div>
                                <div
                                  v-if="
                                    !isRecommend &&
                                    cItem.courseGoodsLearnLogEntity &&
                                    cItem.courseGoodsLearnLogEntity.playTime ==
                                      cItem.courseGoodsLearnLogEntity
                                        .courseGoodsEntity.catLength
                                  "
                                >
                                  已学完
                                </div>
                              </div>
                              <div>
                                <el-button
                                  @click="infoVido(cItem)"
                                  size="small"
                                  type="text"
                                  v-if="
                                    !isRecommend &&
                                    cItem.courseGoodsLearnLogEntity
                                  "
                                  >继续学习</el-button
                                >
                                <el-button
                                  size="small"
                                  type="text"
                                  v-if="!isRecommend"
                                  v-show="cItem.is_free == 1"
                                  >再学习</el-button
                                >
                                <el-button
                                  @click="infoVido(cItem)"
                                  size="small"
                                  type="text"
                                  v-if="
                                    !isRecommend &&
                                    !cItem.courseGoodsLearnLogEntity
                                  "
                                  >开始学习</el-button
                                >
                                <el-button
                                  @click="buycourse()"
                                  size="small"
                                  type="text"
                                  v-if="isRecommend && !cItem.channelFree"
                                  >开通课程</el-button
                                >
                                <el-button
                                  @click="infoVido(cItem)"
                                  size="success"
                                  type="text"
                                  v-if="isRecommend && cItem.channelFree"
                                  style="color: green"
                                  >免费试看</el-button
                                >
                              </div>
                            </div>
                          </div>
                        </el-menu-item>
                      </el-menu-item-group>
                    </el-submenu>
                  </el-menu>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--弹框-->
    <el-dialog
      :show-close="false"
      :visible.sync="centerDialogVisible"
      center
      width="400px"
    >
      <div class="imge">
        <img
          alt
          src="@/assets/img/placeholder.png"
          v-if="courseData.thumb == null"
        />
        <img :src="courseData.thumb" alt v-if="courseData.thumb" />
        <h1>试卷详情：{{ examination.examinationName }}</h1>
        <p>考试时长: {{ testTime }}</p>
        <p>试题题数：{{ examination.questionCount }}</p>
        <p>及格线：{{ examination.pass * 100 }}% （简答题不在计算范围）</p>
        <p>出题规则：{{ examination.keywords }}</p>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button
          @click="StartingToWork"
          class="determine determineButton"
          type="primary"
          >确 定</el-button
        >
        <el-button @click="centerDialogVisible = false" class="determineButton"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Head from '@/components/pc/Head'
import * as COURSE_API from '@/api/ChannelCourseAPI'
import * as Examina_API from '@/api/ExaminationAPI'
import * as CHANNEL_INFO_API from '@/api/ChannelAPI'
export default {
  data () {
    return {
      tourist: localStorage.getItem('tourist') || sessionStorage.getItem('tourist'),
      isRecommend: '',
      examination: {},
      courseData: {},
      courseId: '',
      centerDialogVisible: false,
      showHeader: false,
      actionType: '',
      courseList: [],  //课程视频集合
      datumList: [],
      MyExaminationList: [], // 习题集合
      activeName: 'first',
      activeNames: [1],
      showdata: true,
      showda: false,
      showea: false,
      showdataes: true,
      showdaes: false,
      showeaes: false,
      textCount: 80,
      courseTalkList: [],               //当前考前串讲目录
      courseTopicList: [],               //当前真题讲解目录
      ExaminationItemCollectExamination: [], //试题收藏
      getLearned: 0,                    //已经学习的时间
      examinationItemWrongList: [],
      testTime: 0,
      navActiveIndex: 0,               //课程视频，考前串讲，真题讲解三个tab标签的索引
      back: true,
      isPay: true
    }
  },
  components: {
    Head
  },

  filters: {
    setTime (val) {
      if (val < 60) {
        return val + '秒'
      } else {
        var remainder = val % 60
        var newval = parseInt(val / 60) + '分' + remainder + '秒'
        return newval
      }
    }
  },

  computed: {
  },

  watch: {
  },
  created () {
    //从课程列表进入此课程详细页面
    // 渠道商对接判断
    if (this.$route.query.cat_id && this.$route.query.token && this.$route.query.c_no) {
      this.isPay = false
      this.courseId = this.$route.query.cat_id
      localStorage.setItem('shangke_token', this.$route.query.token)
      localStorage.setItem('c_no', this.$route.query.c_no)
      this.getCourseInfo()
      this.ChannelFindInfo()
      sessionStorage.setItem('isChannel', 'true')
      localStorage.setItem('cat_id', this.$route.query.cat_id)
      this.back = false
    } else if (this.$route.params.data) {
      this.courseData = this.$route.params.courseData
      this.courseId = this.courseData.courseId
      this.isRecommend = this.$route.params.isRecommend
      this.deleteLoc()
    } else {
      this.courseData = JSON.parse(sessionStorage.getItem('curriculumSchedule')).courseData
      this.isRecommend = JSON.parse(sessionStorage.getItem('curriculumSchedule')).isRecommend
      this.courseId = this.courseData.courseId
      this.deleteLoc()
    }
    if (this.isPay) {
      this.isPayList()
    }
  },
  mounted () {
  },

  destroyed () { },
  methods: {

    deleteLoc () {
      localStorage.removeItem('isPopupChannelMsg')
      localStorage.removeItem('isHideOutButton')
    },

    isPayList () {
      this.catalogList()
      this.GetDatumList() //资料
      this.CourseTalkInfo()
      this.CourseTopicInfo()
      this.examinationList()
      //试题收藏
      this.getExaminationItemCollectExamination()
      //错题集合
      this.getExaminationItemWrongExamination()

    },


    ChannelFindInfo () {
      CHANNEL_INFO_API.ChannelFindInfo(null).then(res => {
        this.channelName = res.data.channelName
        this.logoUrl = res.data.logoUrl
        localStorage.setItem('channelName', this.channelName)
        localStorage.setItem('logoUrl', this.logoUrl)
        localStorage.setItem('isPopupChannelMsg', res.data.isPopupChannelMsg)
        localStorage.setItem('isHideOutButton', res.data.isPopupChannelMsg)
      })
    },
    getCourseInfo () {
      let data = {
        courseId: this.courseId,
        tourist: this.tourist
      }
      COURSE_API.GetCourseInfo(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.courseData = res.data
            if (this.courseData == null) {
              this.$message.success('渠道商尚未购买此课程')
            }
            if (this.courseData != null) {
              if (this.courseData.isPay == null || this.courseData.isPay == 0) {
                this.isRecommend = true;
                this.isPayList()
              } else if (this.courseData.isPay == 1) {
                this.isRecommend = false;
                this.isPayList()
              }

            }
          } else {
            console.log('err')
          }
        })
    },

    //错题集合
    getExaminationItemWrongExamination () {
      let data = {
        courseId: this.courseId,
        tourist: this.tourist,
      }
      Examina_API.getExaminationItemWrongExamination(data).then(res => {
        if (res && Number(res.code) === 0) {
          this.examinationItemWrongList = res.data
        } else {
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    //试题收藏
    getExaminationItemCollectExamination () {
      let data = {
        courseId: this.courseId,
        tourist: this.tourist,
      }
      Examina_API.getExaminationItemCollectExamination(data).then(res => {
        this.ExaminationItemCollectExamination = res.data
      })
    },
    //弹窗
    buycourse () {
      this.$message.success('请联系渠道商开通此课程')
    },
    //答题弹窗
    openCenterDialogVisible (data, actionType) {
      this.actionType = actionType
      this.centerDialogVisible = true
      this.examination = data
      this.testTime = this.getDuration(this.examination.testTime)
    },
    //跳转错题页面
    openWrong (data) {
      console.log(data)
      let warongObj = {
        examination: data,
        courseId: this.courseId,
        courseName: this.courseData.courseName,
        typeName: null,
        examinationName: data.examinationName,
        topTypeId: data.topTypeId,
        pushType: 3 //错题
      }
      this.$router.push({
        name: 'WarningView',
        params: warongObj
      })
      sessionStorage.setItem('warning', JSON.stringify(warongObj))
    },
    again (data, actionType) {
      this.actionType = actionType
      this.centerDialogVisible = true
      this.examination = data
      this.testTime = this.getDuration(this.examination.testTime)
      this.StartingToWork();
    },

    //跳转答题页面  actionType 1: 开始答题 2:继续答题  3:重新答题
    StartingToWork () {
      this.centerDialogVisible = false
      let data = {
        examination: this.examination,
        examinationId: this.examination.examinationId,
        courseId: this.courseId,
        courseName: this.courseData.courseName,
        testTime: this.examination.testTime,
        actionType: this.actionType
      }
      setTimeout(() => {
        this.$router.push(
          {
            name: 'AnswerView',
            params: data
          }
        )
        sessionStorage.setItem('answer', JSON.stringify(data))
      }, 200)
    },
    //跳转解析页面
    pushParing (data) {
      this.examination = data
      let parsingObj = {
        examinationData: this.examination,
        courseId: this.courseId,
        examinationId: this.examination.examinationId,
        courseName: this.courseData.courseName,
        typeId: this.examination.typeId
      }
      this.$router.push({
        name: 'ParsingView',
        params: parsingObj
      })
      sessionStorage.setItem('parsing', JSON.stringify(parsingObj))
    },
    //跳转试题收藏
    openBankKeep (data) {
      let BankKeepObj = {
        courseId: this.courseId,
        courseName: this.courseData.courseName,
        examination: data,
      }
      this.$router.push({
        name: 'BankKeep',
        params: BankKeepObj
      })
      sessionStorage.setItem('bankKeep', JSON.stringify(BankKeepObj))
    },
    //跳转视频播放页面
    infoVido (courseGood) {
      let voidData = {
        goodsId: courseGood.goodsId,
        courseId: this.courseId,
        courseName: this.courseData.courseName,
        courseGood: courseGood,
        isRecommend: this.isRecommend,
        tourist: this.tourist,
      }
      console.log(voidData)
      setTimeout(() => {
        this.$router.push(
          {
            name: 'VideoPlay',
            params: voidData
          }
        )
        sessionStorage.setItem('videoPlay', JSON.stringify(voidData))
      }, 200)
    },
    //下载资料
    downloadDatum (row) {
      if (row.agentDatumAddress) {
        window.open(row.agentDatumAddress)
      } else {
        window.open(row.datumAddress)
      }
    },
    //初始化数据
    examinationList () {
      let data = {
        courseId: this.courseId,
        type: 3, //pc,
        tourist: this.tourist,
      }
      COURSE_API.examinationList(data).then(res => {
        console.log(res)
        this.MyExaminationList = res.data
      })
    },
    GetDatumList () {
      let data = {
        courseId: this.courseId,
        tourist: this.tourist,
      }
      COURSE_API.GetDatumList(data).then(res => {
        console.log(res)
        this.datumList = res.data
      })
    },
    tabClicked (index) {
      this.navActiveIndex = index
    },
    catalogList () {
      this.navActiveIndex = 1
      let data = {
        courseId: this.courseId,
        activeIndex: this.navActiveIndex,
        tourist: this.tourist,
      }
      COURSE_API.catalogList(data).then(res => {
        console.log(res)
        this.courseList = res.data
      })
    },
    // 查询考前串讲目录
    CourseTalkInfo () {
      this.navActiveIndex = 2
      let data = {
        courseId: this.courseId,
        activeIndex: this.navActiveIndex,
        tourist: this.tourist,
      }
      COURSE_API.catalogList(data).then(res => {
        console.log(res)
        this.courseTalkList = res.data
      })
    },
    // 查询真题讲解目录
    CourseTopicInfo () {
      this.navActiveIndex = 3
      let data = {
        courseId: this.courseId,
        activeIndex: this.navActiveIndex,
        tourist: this.tourist,
      }
      COURSE_API.catalogList(data).then(res => {
        console.log(res)
        this.courseTopicList = res.data
      })
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    //回退
    slices () {
      this.$router.push('/pc/myCourseList')
    },
    //时间转换
    getDuration (second) {
      var duration
      var days = Math.floor(second / 86400);
      var hours = Math.floor((second % 86400) / 3600);
      var minutes = Math.floor(((second % 86400) % 3600) / 60);
      var seconds = Math.floor(((second % 86400) % 3600) % 60);
      if (days > 0)
        duration = days + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
      else if (hours > 0)
        duration = hours + "小时" + minutes + "分" + seconds + "秒";
      else if (minutes > 0)
        duration = minutes + "分" + seconds + "秒";
      else if (seconds > 0)
        duration = seconds + "秒";
      return duration

    },
    currvideo (appear, e) {
      if (appear == 'appear') {
        if (e == 1) {
          this.showdataes = true
          this.showdaes = false
          this.showeaes = false
        } else if (e == 2) {
          this.showdataes = false
          this.showdaes = true
          this.showeaes = false
        } else if (e == 3) {
          this.showdataes = false
          this.showdaes = false
          this.showeaes = true
        }
      } else {
        if (e == 1) {
          this.showdata = true
          this.showda = false
          this.showea = false
        } else if (e == 2) {
          this.showdata = false
          this.showda = true
          this.showea = false
        } else if (e == 3) {
          this.showdata = false
          this.showda = false
          this.showea = true
        }
      }
    },
  }
}
</script>
<style scoped>
.rightrow {
  float: right;
  margin-left: 10px;
}
::v-deep .el-dialog__header {
  padding: 0;
}
.determineButton {
  width: 98px;
  height: 36px;
  margin-right: 20px;
}
::v-deep .el-dialog__footer {
  background: rgba(241, 241, 241, 1);
}
.determine {
  background: linear-gradient(
    90deg,
    rgba(77, 205, 253, 1),
    rgba(71, 161, 255, 1)
  );
}
.imge h1 {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(25, 25, 25, 1);
  line-height: 64px;
}
.imge p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 30px;
}
.imge img {
  width: 360px;
  height: 202px;
  border-radius: 10px;
  overflow: hidden;
}
.currbox {
  max-width: 1282px;
  margin: 0 auto;
  padding: 52px 52px 56px 52px;
  background: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  margin-top: 30px;
  border-radius: 10px;
}
.switchBox {
  display: flex;
  background: rgba(255, 255, 255, 1);
}
.currhead {
  display: flex;
  justify-content: space-between;
}
.currh1 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 64px;
}
.currfont {
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
  line-height: 64px;
}
.currfontes {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 28px;
}
.tabBox {
  max-width: 1282px;
  margin: 0 auto;
  margin-top: 20px;
}
::v-deep .el-tabs__nav-wrap::after {
  height: 0px;
}
::v-deep .el-tabs__nav-scroll {
  padding-left: 52px;
}
::v-deep .el-tabs__item {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
}
::v-deep .el-tabs__content {
  border-radius: 10px;
}

.buttontab {
  margin-top: 20px;
  width: 98px;
  height: 36px;
  border-radius: 18px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  text-align: center;
  margin-left: 52px;
  cursor: pointer;
  border: 1px solid rgba(242, 242, 242, 1);
}
.buttontabes {
  background: linear-gradient(
    90deg,
    rgba(77, 205, 253, 1),
    rgba(71, 162, 255, 1)
  );
  color: rgba(255, 255, 255, 1);
  margin-top: 20px;
  width: 98px;
  height: 36px;
  border-radius: 18px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  text-align: center;
  margin-left: 52px;
  cursor: pointer;
  border: 1px solid rgba(242, 242, 242, 1);
}
.courseContent {
  padding: 20px;
}
.paddingBox {
  padding: 15px 52px 35px 52px;
  background: rgba(255, 255, 255, 1);
}
.coure {
  display: flex;
  align-items: center;
}
.coure img {
  width: 32px;
  height: 23px;
  margin-right: 10px;
}
.coure div:nth-child(1) {
  width: 100px;
}
.coure div:nth-child(2) {
  width: 550px;
}
.coure div:nth-child(3) {
  width: 200px;
  display: flex;
}
.coure div:nth-child(3) div:nth-child(2),
.coure div:nth-child(3) div:nth-child(1) {
  margin-left: 40px;
}
::v-deep.el-button + .el-button {
  margin-left: 0px;
}
.nt {
  width: 245px;
}
</style>